/**
 * Router which renders views related to `MapService` models.
 * @module app/routers/admin/MapServices
 */

import RouterBase from "app/routers/RouterBase";
import MapService from "app/models/MapService";
import MapServiceCollection from "app/models/MapServiceCollection";
import _ from "underscore";
import $ from "jquery";
import Field from "core/models/Field";
import CollectionTableView from "core/views/CollectionTableView";
import ServiceDetailView from "app/views/admin/mapServices/Details";
import FormView from "core/views/FormView";
import ServiceSelector from "app/views/map/ServiceSelector";
import uriHelper from "urijs";
import NavigationOperations from "core/operations/NavigationOperations";
import ModelOperations from "core/operations/ModelOperations";
import Operation from "core/models/Operation";
import ValueCollections from "app/models/ValueCollections";
import RequestUtils from "app/utils/RequestUtils";
import app from "app/App";
export default RouterBase.extend({
  root: "/admin/mapServices",
  initialize: function (options) {
    RouterBase.prototype.initialize.apply(this, arguments);
  },

  load: function () {
    this.collection = new MapServiceCollection([]);
    this.collection.url = _.result(this.collection, "url") + "?scenario=admin";

    return RequestUtils.fetchToPromise(this.collection);
  },

  routerSettings: {
    title: "Map Services",
  },

  routes: {
    "admin/mapServices": "list",
    "admin/mapServices/Details/:id": "details",
    "admin/mapServices/Create": "create",
    "admin/mapServices/Edit/:id": "edit",
  },

  /**
   * Renders a list of map services.
   */
  list: function () {
    var self = this;
    var fields = this._formFields(["external", "updatedAt", "createdAt"]);

    fields.unshift(
      new Field(
        {
          id: "external",
          name: "external",
          label: "External",
          editable: false,
          filterable: function (model) {
            return model.get("external") ? "Yes" : "No";
          },
        },
        {
          getter: function (model) {
            return model.get("external") ? "Yes" : "No";
          },
        }
      )
    );

    fields.unshift(
      new Field(
        {
          id: "owner",
          name: "owner",
          label: "Owner",
          editable: false,
          filterable: function (model) {
            var owner = model.get("owner");
            var ownerName;

            if (owner) {
              ownerName = owner.PrimaryName;
              var lastName = owner.SecondaryName;
              if (ownerName) {
                if (lastName) {
                  ownerName = ownerName.concat(" ").concat(lastName);
                  return ownerName;
                } else {
                  return ownerName;
                }
              } else {
                ownerName = lastName;
                return ownerName;
              }
            }

            return ownerName;
          },
          valueSource: ValueCollections.User,
        },
        {
          getter: function (model) {
            if (_.isObject(model.get("owner"))) {
              return model.get("owner").id;
            } else {
              return model.get("owner");
            }
          },
        }
      )
    );

    fields.unshift(
      new Field(MapService.fields["name"]).decorate({
        viewOptions: {
          type: "link",
          linkUrl: self.root.substring(1) + "/Details",
          linkField: "name",
          linkDefaultText: "(Unnamed Service)",
        },
        id: "id",
        name: "id",
        filterable: "name",
      })
    );

    var view = new CollectionTableView({
      collection: this.collection,
      fields: fields,
      allowDelete: false,
      allowSave: false,
      mode: "view",
      className: CollectionTableView.prototype.className + " map-service-list",
    });

    view.render();

    app.registerItemAction(
      NavigationOperations.createNavigationOperation("Create", "plus", "Create")
    );

    app.pushView(view);
  },

  /**
   * Renders a view which shows map service details.
   * @param  {string} id The ID of the map service to display.
   */
  details: function (id) {
    var view = new ServiceDetailView({
      model: this.collection.get(id),
      fields: this._formFields([
        "name",
        "url",
        "external",
        "defaultVisibility",
      ]),
    });

    view.render();

    app.registerNavigationAction("back");
    app.registerItemAction(
      NavigationOperations.createNavigationOperation(
        "Edit",
        "pencil",
        "Edit/" + id
      )
    );

    app.setLayout("Wide").done(function () {
      app.pushView(view);
      setTimeout(function () {
        view.delegateEvents();
      }, 1000);
    });
  },

  _formFields: function (fields) {
    if (!_.isArray(fields)) {
      fields = [
        "url",
        "user",
        "pwd",
        "name",
        "server",
        "tokenUrl",
        "mainKey",
        "directoryKey",
        "external",
        "defaultVisibility",
        "snapshot",
        "showLabels",
      ];
    }

    var urlField,
      serverField,
      tokenUrlField,
      urlIndex = false,
      serverIndex = false,
      tokenUrlIndex = false,
      serverClass = "server-field",
      tokenUrlClass = "token-url-field",
      result;

    result = _.map(fields, function (key, index) {
      var result = new Field(MapService.fields[key]);

      if (key == "url") {
        urlField = result;
        urlIndex = index;
      } else if (key == "server") {
        serverField = result;
        serverIndex = index;
      } else if (key == "tokenUrl") {
        tokenUrlField = result;
        tokenUrlIndex = index;
      }

      return result;
    });

    if (serverField && _.isNumber(serverIndex)) {
      serverField = serverField.decorate({
        editor: "custom",
        EditorView: {
          className: serverClass + " form-control",
          tagName: "input",

          template: _.template("<%-value%>"),

          postRender: function () {
            var model = this.options.model;
            var self = this;

            function updatePlaceholder() {
              var placeholder = "";
              var url = model.get("url");

              if (url) {
                var urlInfo = uriHelper(url);

                placeholder = urlInfo.protocol() + "://" + urlInfo.host();
                placeholder = "Defaults to " + placeholder;
              }

              self.$el.attr("placeholder", placeholder);
            }

            model.on("change:url", updatePlaceholder);
            updatePlaceholder();
          },

          getControlValue: function () {
            return this.$el.val();
          },

          setControlValue: function (value) {
            this.$el.val(value);
          },
        },
      });

      result[serverIndex] = serverField;
    }

    if (tokenUrlField && _.isNumber(tokenUrlIndex)) {
      tokenUrlField = tokenUrlField.decorate({
        editor: "custom",
        EditorView: {
          className: tokenUrlClass + " form-control",
          tagName: "input",

          template: _.template("<%-value%>"),

          postRender: function () {
            var model = this.options.model;
            var self = this;

            function updatePlaceholder() {
              var placeholder = "";
              var url = model.get("url");

              if (url) {
                var urlInfo = uriHelper(url);
                var serverDefault = urlInfo.protocol() + "://" + urlInfo.host();

                placeholder = serverDefault + "/arcgis/tokens/";
                placeholder = "Defaults to " + placeholder;
              }

              self.$el.attr("placeholder", placeholder);
            }

            model.on("change:url", updatePlaceholder);
            updatePlaceholder();
          },

          getControlValue: function () {
            return this.$el.val();
          },

          setControlValue: function (value) {
            this.$el.val(value);
          },
        },
      });

      result[tokenUrlIndex] = tokenUrlField;
    }

    if (urlField && _.isNumber(urlIndex)) {
      urlField = urlField.decorate({
        viewOptions: {
          className: "url-value",
        },
      });

      result[urlIndex] = urlField;
    }

    return result;
  },

  /**
   * Renders a view which can be used to create a map service.
   */
  create: function () {
    var model = new MapService();

    model.collection = this.collection;
    var view = new FormView({
      fields: this._formFields(),
      model: model,
      className: FormView.prototype.className + " map-service-create",
    });

    view.render();

    app.registerNavigationAction("back");
    app.registerItemAction(
      ModelOperations.create("Map Service", view, this.collection, true),
      model
    );

    app.pushView(view);
  },

  /**
   * Renders a view which can be used to modify a map service.
   * @param  {string} id The ID of the map service to modify.
   */
  edit: function (id) {
    var model = this.collection.get(id);
    var self = this;
    var view = new FormView({
      fields: this._formFields(),
      model: model,
      className: FormView.prototype.className + " map-service-edit",
    });

    view.render();

    app.registerNavigationAction("back");

    var deleteView;

    if (model.get("external")) {
      deleteView = app.registerItemAction(
        ModelOperations.destroy("Map Service", this.collection),
        model
      );
    } else {
      deleteView = app.registerItemAction(
        new Operation({
          id: "destroy-service",
          icon: "remove",
          text: "Delete",
          action: function (model) {
            var deferred = new $.Deferred();

            ServiceSelector.destroyService(model, function (err) {
              if (err) {
                if (_.isString(err)) {
                  deferred.reject(err);
                } else {
                  deferred.reject(false);
                }
              } else {
                deferred.resolve(model, "Map service deleted.");
                self.collection.remove(model);
                setTimeout(function () {
                  RouterBase.relativeNavigate("", {
                    trigger: true,
                  });
                }, 800);
              }
            });

            return deferred.promise();
          },
        }),
        model
      );
    }
    app.registerItemAction(
      ModelOperations.save("Map Service", view, true),
      model
    );

    app.pushView(view);

    setTimeout(function () {
      view.delegateEvents();
    }, 1000);
  },
});



//////////////////
// WEBPACK FOOTER
// ./public/js/app/routers/admin/MapServices.js
// module id = 924
// module chunks = 1